export default __webpack_public_path__ + "static/media/fan.453a64fb.png";